import React from 'react';
import moment from 'moment';

// With FullCalendar v7, it’s possible to return React JSX nodes.
// https://fullcalendar.io/docs/react#content-injection

function OpDayHeader({ date = new Date(), weekdayText = '' }) {
  const monthDayText = moment(date).format('DD MMM').toLocaleUpperCase();

  return (
    <span>
      {monthDayText}, {weekdayText}
    </span>
  );
}

export default OpDayHeader;
